<template>
  <div v-if="isShow">
    <div class="exp" v-for="(item, index) in expList.results" :key="index">
      <!-- <router-link :to="{path:'/newsIndexDetail',query:{news:item}}"> -->
      <div @click="getExp(item.id, item)">
        <div class="left">
          <img :src="item.imageUrl" alt />
        </div>
        <div class="right">
          <div class="title">{{ item.title }}</div>
          <div class="content">{{ item.summary }}</div>
          <p class="date">{{ (item.createTime * 1000) | formatDate }}</p>
        </div>
      </div>
      <!-- </router-link> -->
      <!-- <div class="line"></div> -->
    </div>
    <div class="more" @click="getMore">
      <p v-if="isMore">查看更多>></p>
      <p v-else>全部加载完毕...</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["navID"],
  metaInfo: {
    meta: [
      {
        name: "keywords",
        content: "博为峰51Testing,软件测试,软件测试培训,学员心得"
      },
      {
        name: "description",
        content: "博为峰51Testing培训学员的转行、学习、就业真实经历分享."
      }
    ]
  },
  // JSON-LD 结构化数据
  script: [
    {
      vmid: "json_ld_course",
      type: "application/ld+json",
      innerHTML: JSON.stringify({
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "Webpage",
            "@id": "https://www.51testing.net/xinde.html#webpage",
            name: "学员心得_资讯中心_博为峰51Testing软件测试培训官网",
            description:
              "博为峰51Testing培训学员的转行、学习、就业真实经历分享.",
            url: "https://www.51testing.net/xinde.html",
            inLanguage: "zh-CN",
            publisher: {
              "@id": "https://www.boweifeng.com/#organization"
            }
          }
        ]
      }),
      __dangerouslyDisableSanitizers: ["script"]
    }
  ],
  data() {
    return {
      expList: [],
      isShow: true,
      count: "",
      isMore: true
    };
  },
  watch: {
    navID: {
      handler: function() {
        if (this.navID === 4) {
          this.isShow = true;
        } else {
          this.isShow = false;
        }
      },
      immediate: true
    },
    count: {
      handler: function() {
        if (this.count > this.expList.count) {
          this.isMore = false;
        }
        this.getNews();
      },
      immediate: true
    }
  },
  methods: {
    getExp(id, item) {
      this.$router.push({ path: `/newsIndex/speech/${id}.html` });
      sessionStorage.setItem("newsId", id);
    },
    getMore() {
      this.count += 4;
    },
    getNews() {
      this.axios
        .get("/api/consume/Information/PageList", {
          params: {
            Type: 4,
            rows: this.count
          }
        })
        .then(res => {
          this.expList = res.data;
        });
    }
  },
  mounted() {
    this.count = 4;
  }
};
</script>

<style scoped>
.exp {
  margin-top: 10px;
  overflow: hidden;
  padding-top: 34px;
  clear: both;
  padding: 30px;
  background: #ffffff;
}
.left {
  float: left;
}
.right {
  float: left;
  width: 65%;
}
.left img {
  width: 240px;
  height: 170px;
  border-radius: 10px;
}
.right .title {
  font-size: 26px;
  color: #444444;
  margin-left: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  font-weight: normal;
  width: 94%;
  margin-bottom: 7px;
}
.right .content {
  font-size: 22px;
  color: #8b8b8b;
  padding-top: 7px;
  margin-left: 14px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  width: 94%;
  border-top: #e2e2e2 1px solid;
  line-height: 32px;
}
.news .line {
  color: #e2e2e2;
  height: 2px;
  margin-top: 190px;
}
.more {
  /* margin-bottom: 64px; */
  padding: 39px 0;
}
.more p {
  color: #747474;
  font-size: 26px;
  text-align: center;
}
.right .date {
  color: #e2e2e2;
  font-size: 22px;
  clear: both;
  margin-left: 14px;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/information/Experience.vue